<template>
  <div>
    <Menu
      :key="activeIndex"
      mode="horizontal"
      :active-name="activeIndex"
      class="project-menu"
      @on-select="handleSelect"
    >
      <Submenu name="2">
        <template slot="title">{{ $t("tabs.home.opportunity") }}</template>
        <MenuItem :name="OPPORTUNITY_TAB.PROJECT">{{
          $t("label.exhibition.globalProject")
        }}</MenuItem>
        <MenuItem :name="OPPORTUNITY_TAB.BIDDING">{{
          $t("label.exhibition.overseasTendering")
        }}</MenuItem>
        <MenuItem :name="OPPORTUNITY_TAB.EXHIBITION">{{
          $t("label.exhibition.internationalExhibition")
        }}</MenuItem>
      </Submenu>
      <Submenu name="3">
        <template slot="title">{{ $t("tabs.home.risk") }}</template>
        <MenuItem name="riskInfo">{{ $t("tabs.information.riskInformation") }}</MenuItem>
        <MenuItem name="riskEvent">{{ $t("tabs.information.riskEvent") }}</MenuItem>
      </Submenu>
    </Menu>
    <div class="breadcrumb-container">
      <Breadcrumb separator="/">
        <BreadcrumbItem>{{ activeFirstLabel }}</BreadcrumbItem>
        <BreadcrumbItem>{{ activeLabel }}</BreadcrumbItem>
      </Breadcrumb>
    </div>

    <List v-show="isList" />
    <Exhibition ref="exhibition" v-show="isExhibition" />
    <TenderingList v-show="isTendering" />
    <RiskInfo v-show="isRiskInfo" />
    <RiskEvent v-show="isRiskEvent" />
  </div>
</template>
<script>
import List from "./List.vue";
import Exhibition from "./Exhibition.vue";
import TenderingList from "./TenderingList.vue";
import RiskInfo from "./RiskInfo.vue";
import RiskEvent from "./RiskEvent.vue";
import {
  Menu,
  Submenu,
  MenuItem,
  Breadcrumb,
  BreadcrumbItem
} from "view-design";
import {
  OPPORTUNITY_TAB,
  DEFAULT_OPPORTUNITY_TAB,
  normalizeOpportunityTab
} from "./opportunityTabs";
export default {
  name: "ProjectIndex",
  components: {
    Menu,
    Submenu,
    MenuItem,
    Breadcrumb,
    BreadcrumbItem,
    List,
    Exhibition,
    TenderingList,
    RiskEvent,
    RiskInfo
  },
  data() {
    return {
      OPPORTUNITY_TAB,
      activeIndex: DEFAULT_OPPORTUNITY_TAB
    };
  },
  computed: {
    activeLabel() {
      if (this.activeIndex === OPPORTUNITY_TAB.EXHIBITION) {
        return this.$t("label.exhibition.internationalExhibition");
      }
      if (this.activeIndex === OPPORTUNITY_TAB.BIDDING) {
        return this.$t("label.exhibition.overseasTendering");
      }
      if (this.activeIndex === 'riskInfo') {
        return '风险资讯';
      }
      if (this.activeIndex === 'riskEvent') {
        return '风险事件';
      }
      return this.$t("label.exhibition.globalProject");
    },
    activeFirstLabel() {
      if (this.activeIndex === 'riskInfo') {
        return '风险';
      }
      if (this.activeIndex === 'riskEvent') {
        return '风险';
      }
      return this.$t("tabs.home.opportunity");
    },
    isList() {
      return this.activeIndex === OPPORTUNITY_TAB.PROJECT;
    },
    isExhibition() {
      return this.activeIndex === OPPORTUNITY_TAB.EXHIBITION;
    },
    isTendering() {
      return this.activeIndex === OPPORTUNITY_TAB.BIDDING;
    },
    isRiskInfo() {
      return this.activeIndex === 'riskInfo';
    },
    isRiskEvent() {
      return this.activeIndex === 'riskEvent';
    }
  },
  watch: {
    "$route.query.tab": {
      handler() {
        this.syncTabFromRoute();
      }
    }
  },
  created() {
    this.syncTabFromRoute();
  },
  activated() {
    this.syncTabFromRoute();
  },
  methods: {
    syncTabFromRoute() {
      const tab = normalizeOpportunityTab(this.$route.query.tab);
      if (tab) {
        this.activeIndex = tab;
      }
    },
    handleSelect(index) {
      this.activeIndex = index;
      if (this.$route.query.tab !== index) {
        this.$router.replace({
          path: "/pbr/project",
          query: { ...this.$route.query, tab: index }
        });
      }
      if (index === OPPORTUNITY_TAB.EXHIBITION) {
        this.$nextTick(() => {
          const exhibition = this.$refs.exhibition;
          if (!exhibition) return;
          if (!exhibition.hotWordData.length) {
            exhibition.search();
          } else if (exhibition.$refs.hotWordChart) {
            exhibition.$refs.hotWordChart.resize();
          }
        });
      }
    }
  }
};
</script>
<style scoped>
>>> .project-menu.ivu-menu-horizontal {
  height: 40px;
  line-height: 40px;
}
>>> .project-menu.ivu-menu-horizontal > .ivu-menu-submenu {
  height: 40px;
  line-height: 40px;
}
.breadcrumb-container {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
